import { useRecoilState, useRecoilValue } from 'recoil';
import { editingFenceState, selectedFenceIdState, selectedFenceState } from '../../../storage/fences';
import CoreDrawControls from './CoreDrawControls';

function FenceDrawControls() {
  const fencePolygon = useRecoilValue(selectedFenceState)?.polygon;
  const selectedFenceId = useRecoilValue(selectedFenceIdState);
  const [editingFence, setEditingFence] = useRecoilState(editingFenceState);

  return (
    <CoreDrawControls
      updateKey={selectedFenceId}
      polygon={fencePolygon}
      updatedPolygon={editingFence?.polygon}
      onUpdatePolygon={(polygon) => {
        if (editingFence) {
          setEditingFence((prev) => ({ ...prev!, polygon }));
        }
      }}
    />
  );
}

export default FenceDrawControls;
